import { render, staticRenderFns } from "./NewAddress.vue?vue&type=template&id=055383d2&scoped=true&"
import script from "./NewAddress.vue?vue&type=script&lang=js&"
export * from "./NewAddress.vue?vue&type=script&lang=js&"
import style0 from "./NewAddress.vue?vue&type=style&index=0&id=055383d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055383d2",
  null
  
)

export default component.exports